import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const hasFirebaseConfig = Object.values(firebaseConfig).every(Boolean);

let analyticsPromise = Promise.resolve(null);

if (hasFirebaseConfig && typeof window !== 'undefined') {
  const app = initializeApp(firebaseConfig);
  analyticsPromise = isSupported()
    .then((supported) => (supported ? getAnalytics(app) : null))
    .catch(() => null);
}

const cleanEventParams = (params = {}) => Object.entries(params).reduce((acc, [key, value]) => {
  if (value === undefined || value === null || value === '') return acc;
  acc[key] = value;
  return acc;
}, {});

export const logAnalyticsEvent = (eventName, params = {}) => {
  if (!hasFirebaseConfig) return;

  analyticsPromise.then((analytics) => {
    if (!analytics) return;
    logEvent(analytics, eventName, cleanEventParams(params));
  });
};

export const logPageView = (pagePath, pageTitle = document.title) => {
  logAnalyticsEvent('page_view', {
    page_path: pagePath,
    page_title: pageTitle,
    page_location: `${window.location.origin}${pagePath}`
  });
};
